var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-umbrella",
  "use": "ring-icon-umbrella-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"ring-icon-umbrella\"><path d=\"M11.36 8.89L7.71 5.25l2.76-2.75a.54.54 0 0 0 0-.76l-.08-.1a5.22 5.22 0 0 0-6.79-.49L2.76.3a.58.58 0 0 0-.84 0 .59.59 0 0 0 0 .85l.83.85A5.2 5.2 0 0 0 3 9l.08.07a.57.57 0 0 0 .38.15.54.54 0 0 0 .39-.16l3-3 3.64 3.64a.55.55 0 0 1 .16.38.55.55 0 0 1-.16.39.57.57 0 0 1-.77 0 .59.59 0 0 0-.85 0 .61.61 0 0 0 0 .85 1.75 1.75 0 0 0 2.47-2.47zm-7.87-1a4.13 4.13 0 0 1 3.23-6.68 4 4 0 0 1 2.57.91z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id